import { render, staticRenderFns } from "./OrderRouteResults.vue?vue&type=template&id=71d0b966&"
import script from "./OrderRouteResults.js?vue&type=script&lang=js&"
export * from "./OrderRouteResults.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports